module.exports = __webpack_public_path__ + "media/images/camera-btn-b4c36da3e23cfbe13e49cda359e06e69.png";